const MEMEGENES_BASE = 'https://memegenes.com';

/** URL of an original's Gene detail page on MemeGenes. */
export function geneUrl(geneId: string): string {
  return `${MEMEGENES_BASE}/gene/${geneId}`;
}
